export function formatFromUrl(url: string): string {
  if (url.includes(".woff2")) {
    return "woff2";
  }
  if (url.includes(".woff")) {
    return "woff";
  }
  if (url.includes(".ttf")) {
    return "truetype";
  }
  if (url.includes(".otf")) {
    return "opentype";
  }
  return "truetype";
}
